import { useState } from 'react';
import { _TypedDataEncoder } from 'ethers/lib/utils';
import { useSwap } from '@/contexts/SwapProvider';
import PortfolioAssetSelect from '@/components/trade/PortfolioAssetSelect';
import classNames from '@/lib/misc/classNames';
import PercentageView from '@/components/trade/PercentageView';
import SwapTabMobile from './SwapTabMobile';
import SelectToAsset from '../mobile/SelectToAsset';
import SlidingModal from '@/components/home/mobile/SlidingModal';
import MobileMenu from '@/components/shared/MobileMenu';
export default function SwapHomeMobile({
  className
}: {
  className?: string;
}) {
  const {
    selectFromAsset,
    setSelectFromAsset,
    selectToAsset,
    setSelectToAsset,
    fromAssets,
    setFromAssets,
    toAssets,
    setToAssets,
    amount,
    buyAmount,
    isConfirmationDialogOpen
  } = useSwap();
  const [selectPercentageTo, setSelectPercentageTo] = useState(false);
  const [selectPercentageBuy, setSelectPercentageBuy] = useState(false);
  const [amountSelect, setAmountSelect] = useState(false);
  return <div className={classNames('bg-genius-indigo h-screen w-full  overflow-clip relative', className)} data-sentry-component="SwapHomeMobile" data-sentry-source-file="SwapHomeMobile.tsx">
      {selectFromAsset ? <div className='border-b w-full h-full lg:flex lg:flex-col lg:justify-between'>
          {selectFromAsset ? <>
              <SlidingModal heightFit={true} isOpen={!amountSelect} onClose={() => {
          setSelectFromAsset(false);
        }}>
                <PortfolioAssetSelect setFromAssets={setFromAssets} fromAssets={fromAssets} singleSelect={true} handleConfirm={() => {
            if (fromAssets.length > 1) {
              setAmountSelect(true);
            } else {
              setSelectFromAsset(false);
            }
          }} confirmBtnParentDivClass='bottom-10 w-full' confirmBtnClass='w-full' />
              </SlidingModal>
            </> : <PortfolioAssetSelect setFromAssets={setFromAssets} fromAssets={fromAssets} singleSelect={false} mobile={true} />}
        </div> : selectToAsset ? <SelectToAsset setToAssets={setToAssets} selectToAsset={selectToAsset} toAssets={toAssets} fromAssets={fromAssets} setSelectFromAsset={setSelectFromAsset} setSelectToAsset={setSelectToAsset} /> : selectPercentageTo || selectPercentageBuy ? <>
          {selectPercentageTo ? <PercentageView toAssets={toAssets} setToAssets={setToAssets} setSelectPercentage={setSelectPercentageTo} setSelectToAsset={setSelectToAsset} amount={amount} /> : <PercentageView toAssets={toAssets} setToAssets={setToAssets} setSelectPercentage={setSelectPercentageBuy} setSelectToAsset={setSelectToAsset} amount={buyAmount} />}
        </> : <div className={`w-full h-full pt-4`}>
          <SwapTabMobile />
          {(!selectToAsset || !selectFromAsset) && !isConfirmationDialogOpen && <MobileMenu />}
        </div>}
    </div>;
}